import { GPS } from "../../util/geo";

export type Amenity = {
  name: string;
  /** OSM tag value, e.g. "supermarket", "school", "restaurant". */
  kind: string;
  distanceM: number;
};

/**
 * Fetch nearby OpenStreetMap "voorzieningen" (POIs) around a [lng, lat] center,
 * via our backend OSM endpoint. Results are pre-filtered to relevant
 * amenity/shop/leisure/tourism tags and sorted by distance.
 */
async function amenities(center: GPS): Promise<Amenity[]> {
  const response = await fetch(`/api/amenities?c=${center[0]},${center[1]}`);
  if (!response.ok) throw new Error(`HTTP status ${response.status}`);
  return response.json();
}

export const OSMService = { amenities };
